import type { AddToCartPayload } from "@model/Cart.model";
import { CART_ADD_ITEM } from "./CartActionTypes";
export const addToCartAction =
  (payload: AddToCartPayload) =>
  (dispatch: any) => {
    dispatch({ type: CART_ADD_ITEM, payload });
  };
